var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$GVO.isEmpty(_vm.objTask))?_c('ReCardTask',{staticClass:"taskStatus",attrs:{"objTask":_vm.objTask,"objService":_vm.objService}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }